import { render, staticRenderFns } from "./homeNav.vue?vue&type=template&id=2136ed84&scoped=true"
import script from "./homeNav.vue?vue&type=script&lang=js"
export * from "./homeNav.vue?vue&type=script&lang=js"
import style0 from "./homeNav.vue?vue&type=style&index=0&id=2136ed84&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2136ed84",
  null
  
)

export default component.exports